import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import AutoBindComponent from "../common/AutoBindComponent";

import generateGuid from "../../util/guid";
import Tooltip from "../common/Tooltip";
import * as types from "../../constants/ComponentConstants";
import ValidationMessage from "../common/ValidationMessage";
import Revert from "../common/Revert";

import { Dropdown } from "semantic-ui-react";

class AdresAutoComplete extends AutoBindComponent {
	constructor(props, context) {
		super(props, context);

		this.MINSEARCHLENGTH = typeof props.minSearchLength === "undefined" ? 1 : props.minSearchLength;

		this.valueKey = props.valueKey ? props.valueKey : 'value';
		this.labelKey = props.labelKey ? props.labelKey : 'label';

		this.state = {
			search: ''
		};
	}

	shouldComponentUpdate(nextProps, nextState) {
		return this.props.value !== nextProps.value || this.state.search !== nextState.search || this.props.validationMessage !== nextProps.validationMessage || this.props.disabled !== nextProps.disabled;
	}

	handleOnSearch(e, event) {
		const options = [];
		const valueKey = this.valueKey;
		const labelKey = this.labelKey;
		const searchQuery = event.searchQuery;
		if (searchQuery.length > this.MINSEARCHLENGTH) {
			const searchresults = this.props.items.filter(item => {
				if (typeof item[labelKey] === 'string')
					return item[labelKey].toLowerCase().match(searchQuery.toLowerCase());
				else
					return item[labelKey].match(searchQuery);
			});

			if (searchresults.length === 0 && this.props.allowUnknownItems) {
				options.push({ text: searchQuery, value: searchQuery, description: `Onbekend ${this.props.label.toLowerCase()}` });
			}

			for (let i = 0; i < searchresults.length; i++) {
				options.push({ text: searchresults[i][labelKey], value: searchresults[i][valueKey] });
			}
		}
		const state = { options: options, search: searchQuery };

		this.setState(state);
	}

	handleOnChange(e, data) {
		if (this.props.onChange) {
			const event = data ? { target: data } : e;
			this.props.onChange(event, data);
		}
	}

	getLabelItemByValue(value, noId) {
		const valueKey = this.valueKey;
		const labelKey = this.labelKey;

		if (!noId) {
			let label = "";
			const item = this.props.items.find(item => item[valueKey] == value);
			if (item != null) {
				label = item[labelKey];
			} else if (this.props.allowUnknownItems){
				return value;
			}
			return label;
		}
		return value;
	}

	render() {
		const noId = this.props.hasNoId;
		const hasValidationMessage = !!this.props.validationMessage;
		const validationMessageType = this.props.validationMessageType;
		const tooltiptype = this.props.tooltipType || types.TOOLTIP_INFO;
		const defaultItem = this.props.defaultItem ? this.props.defaultItem : "Kies een optie";
		const value = this.props.value ? this.props.value : "";
		const sizeClassName = this.props.size ? "o-col-" + this.props.size : "o-col-12";
		const label = this.props.label + (this.props.optional ? " (Optioneel)" : "");
		const info = this.props.tooltip ? <Tooltip isInput text={this.props.tooltip} tooltipType={tooltiptype} /> : null;
		const validation = this.props.validationMessage ? <ValidationMessage message={this.props.validationMessage} type={validationMessageType} /> : null;
		const icon = 'search';
		const id = generateGuid();
		const noResultsMessage = this.props.noResultsMessage ? this.props.noResultsMessage :  `Tik (${this.MINSEARCHLENGTH + 1} letters) en zoek`;
		let text = "";


		const inputClassName = classnames({
			"c-input__field": true
		});
		const labelClassName = classnames({
			"c-input__label": true,
			"has-value": true
		});

		const containerClassName = classnames({
			"c-input": true,
			"c-input--dropdown": true,
			"has-value": true,
			"error": hasValidationMessage && validationMessageType !== types.ValidationMessageTypes.WARNING,
			"warning": hasValidationMessage && validationMessageType === types.ValidationMessageTypes.WARNING,
			"disabled": this.props.disabled
		});
		if (value) {
			text = this.getLabelItemByValue(value, noId);
		}

		const revertable = this.props.originalValue !== undefined ? this.props.originalValue !== value : false;

		const options = this.state.options ? this.state.options : [];
		return (
			<div className={sizeClassName}>
				<div className={containerClassName}>
					<Dropdown
						id={id}
						className={inputClassName}
						fluid
						text={text}
						selection
						icon={icon}
						search
						name={this.props.name}
						closeOnChange
						options={options}
						placeholder={defaultItem}
						onChange={this.handleOnChange}
						disabled={this.props.disabled}
						loading={this.props.loading}
						onSearchChange={this.handleOnSearch}
						noResultsMessage={noResultsMessage}
					/>
					<label className={labelClassName} htmlFor={id}>{label}</label>
					{info}
					{!revertable || <Revert
						onChange={this.handleOnChange}
						name={this.props.name}
						originalValue={this.props.originalValue} />}
				</div>
				{validation}
			</div>
		);
	}
}

AdresAutoComplete.propTypes = {
	name: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	value: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),
	originalValue: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),
	tooltip: PropTypes.string,
	tooltipType: PropTypes.string,
	validationMessage: PropTypes.string,
	validationMessageType: PropTypes.string,
	disabled: PropTypes.bool,
	readOnly: PropTypes.bool,
	size: PropTypes.number,
	optional: PropTypes.bool,
	defaultItem: PropTypes.string,
	items: PropTypes.array.isRequired,
	loading: PropTypes.bool,
	hasNoId: PropTypes.bool,
	noResultsMessage: PropTypes.string,
	valueKey: PropTypes.string,
	labelKey: PropTypes.string,
	minSearchLength: PropTypes.number,
	allowUnknownItems: PropTypes.bool
};

export default AdresAutoComplete;
